import httpPost from './httppost';
import httpPut from './httpPut';
const domain = 'https://webapi.foxitcloud.cn';
import { store } from '../../store/store.index';
// 保存文件至云办公
export const interviewInvitePost = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/interviewInvite`,
    params: config.params,
    config,
  });
};
// 更新文件至云办公
export const interviewInvitePut = (config = {}) => {
  return httpPut({
    url: `${domain}/v1/api/interviewInvite`,
    params: config.params,
    config,
  });
};
//验证token有没有过期
export const getValidateCookieAccessToken = () => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${domain}/accountopenapi/authorization/validateCookieAccessToken?domain=.foxitcloud.cn`);
    xhr.setRequestHeader('Authorization', `Bearer ${store.loginNewStore.IAMToken}`);
    xhr.withCredentials = true;
    xhr.onload = function () {
      if (xhr.status === 200) {
        const res = JSON.parse(xhr.responseText);
        if (res.code === 0) {
          resolve(res);
        } else {
          resolve(res);
        }
      } else {
        reject();
      }
    };
    xhr.onerror = function () {
      reject();
    };
    xhr.send();
  });
};
//请求clound getcookie
export const getCloudCookie = () => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://docsapi.foxitcloud.cn/auth/getCookies`);
    xhr.withCredentials = true;
    xhr.onload = function () {
      if (xhr.status === 200) {
        var jsonString = xhr.responseText.replace(/^var cloudCookies=/, '');
        var res = JSON.parse(jsonString);
        resolve(res);
      } else {
        reject();
      }
    };
    xhr.onerror = function () {
      reject();
    };
    xhr.send();
  });
};
//请求reader getcookie
export const getReaderCookie = () => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://sso.foxitreader.cn/getCookies`);
    xhr.withCredentials = true;
    xhr.onload = function () {
      if (xhr.status === 200) {
        var jsonString = xhr.responseText.replace(/^var readerCookies=/, '');
        var res = JSON.parse(jsonString);
        resolve(res);
      } else {
        reject();
      }
    };
    xhr.onerror = function () {
      reject();
    };
    xhr.send();
  });
};
